'use client';
import { createIntl } from '@formatjs/intl';
import { use } from 'react';

function useGetIntl(params) {
    const { lang, dictionaryPromise } = params;
    const messages = dictionaryPromise && typeof dictionaryPromise === "object" && "then" in dictionaryPromise ? use(dictionaryPromise) : dictionaryPromise;
    const intl = createIntl({
        locale: lang,
        messages
    });
    return intl;
}

export { useGetIntl };
